/**
 * Scope Label — shows Aircraft/System/Equipment (or tenant-custom term)
 * for the current project in the Project Context Bar.
 *
 * See: .kiro/specs/phase1-tier1-ux-fixes/requirements.md Requirement 2
 *
 * @module components/ScopeLabel
 */
import { getScopeLabel, type AnalysisScope, type ScopeTerminology } from '../shared/analysisScope';

interface ScopeLabelProps {
  scope: AnalysisScope | undefined | null;
  terminology?: ScopeTerminology;
}

export function ScopeLabel({ scope, terminology }: ScopeLabelProps) {
  const label = getScopeLabel(scope, terminology);
  if (!label) return null;

  return (
    <span
      className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px]
                 bg-sn-blue-50 dark:bg-sn-blue-900/30
                 text-sn-blue-700 dark:text-sn-blue-200
                 font-medium"
      title={`Analysis scope for this project: ${label}`}
      aria-label={`Scope: ${label}`}
    >
      {label}
    </span>
  );
}
